var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payments-filter filters-container"},[_c('sorting-control',{attrs:{"type":"payments","values":_vm.sortingFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }